<template>
    <section class="leitura-p">
        <div class="container">
            <div class="row" v-for="(pj, index) in postLeitura" :key="index">
                <div class="col-lg-12 mt-5">
                    <div class="titulo-post text-center">
                        <h2>
                            {{ pj.titulo }}
                        </h2>
                    </div>
                </div>
                <div class="col-lg-12 mt-4">
                    <div class="texto">
                        <p v-html="pj.conteudo"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Popup/>
    <FooterInternasVue/>
</template>
<script>
import axios from 'axios';

import FooterInternasVue from '@/components/FooterInternas/FooterInternas.vue';
import Popup from '@/components/Popup/PopupComponent.vue';

export default {
    name: 'LeituraPj',
    components: {
        FooterInternasVue,
        Popup
    },
    data() {
        return  {
            postLeitura: []
        }
    },
    watch: {
        $route() {
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            const PJPOST = 'https://api.cref20.org.br/wp-json/cref/v1/pessoa-juridica/' + this.$route.params.link;

            axios.get(PJPOST).then((response) => {
                this.postLeitura = response.data.map((dados) => ({
                    titulo: dados.titulo,
                    conteudo: dados.texto_conteudo
                }));
            })
        }
    },
    created() {
        this.fetchData()
    }
}
</script>

<style scoped>
    
</style>